import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';

export class AccountOrderDesk extends BaseJs {
    constructor(template: keyof LiquidTemplates) {
        super(template);
    }
}
